<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-dependent-view />

    <core-footer />

  </v-app>
</template>

<script>

export default {
  name: 'Dependent',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreDependentView: () => import('../components/core/DependentView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
